import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrCreateFileCategoryPayload } from 'api/actions/hr-create-file-category/hr-create-file-category-payload';
import { HrCreateFileCategoryPathParameters } from 'api/actions/hr-create-file-category/hr-create-file-category-path-parameters';
import { HrCreateFileCategoryResponse } from 'api/actions/hr-create-file-category/hr-create-file-category-response';

type HrCreateFileCategoryQueryParameters = Record<string, any>;

/**
 * The path of the HrCreateFileCategory action.
 */
export const hrCreateFileCategoryActionPath = new SweetPath<keyof HrCreateFileCategoryPathParameters>(
  '/api/hr/file-categories',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrCreateFileCategory actions.
 */
export default function createHrCreateFileCategoryAction(axios: AxiosInstance) {
  return function hrCreateFileCategoryAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HrCreateFileCategoryQueryParameters;
    payload: HrCreateFileCategoryPayload;
  }) {
    const path = hrCreateFileCategoryActionPath.original;

    return axios.request<HrCreateFileCategoryResponse, HrCreateFileCategoryResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
